<form [formGroup]="form" (ngSubmit)="model ? update() : create()">
    <div class="form-row mt-3">
        <div class="form-field flex-grow-1">
            <input pInputText type="text" formControlName="identificador" class="form-control"
                [placeholder]="'Ingrese clave de empresa'" [disabled]="model">
            <label>Clave Empresa</label>
        </div>
        <div class="form-field flex-grow-1">
            <input pInputText type="text" formControlName="nombre" class="form-control"
                [placeholder]="'Ingrese nombre de empresa'">
            <label>Nombre Empresa</label>
        </div>
        <div class="form-field flex-grow-1">
            <input pInputText type="text" formControlName="calle" class="form-control" [placeholder]="'Ingrese calle'">
            <label>Calle</label>
        </div>
        <div class="form-field flex-grow-1">
            <input pInputText type="text" formControlName="numext" class="form-control"
                [placeholder]="'Ingrese número exterior'">
            <label>Número Exterior</label>
        </div>
        <div class="form-field flex-grow-1">
            <input pInputText type="text" formControlName="numint" class="form-control"
                [placeholder]="'Ingrese número interior'">
            <label>Número Interior</label>
        </div>
        <div class="form-field flex-grow-1">
            <input pInputText type="text" formControlName="ciudad" class="form-control"
                [placeholder]="'Ingrese ciudad'">
            <label>Ciudad</label>
        </div>
        <div class="form-field flex-grow-1">
            <input pInputText type="text" formControlName="del_muni" class="form-control"
                [placeholder]="'Ingrese delegación/municipio'">
            <label>Delegación/Municipio</label>
        </div>
        <div class="form-field flex-grow-1 mt-1">
            <p-dropdown formControlName="cve_estado" [options]="estadosOpciones" optionLabel="sOpcion"
                optionValue="sOpcion" placeholder="Seleccione estado">
            </p-dropdown>
            <label>Estado</label>
        </div>
        <div class="form-field flex-grow-1 mt-1">
            <p-dropdown formControlName="estatus" [options]="estatusOpciones" optionLabel="sOpcion"
                optionValue="sOpcion" placeholder="Seleccione estatus">
            </p-dropdown>
            <label>Estatus</label>
        </div>
        <div class="form-field flex-grow-1">
            <input pInputText type="text" formControlName="telefono" class="form-control"
                [placeholder]="'Ingrese teléfono'">
            <label>Teléfono</label>
        </div>
        <div class="form-field flex-grow-1">
            <input pInputText type="text" formControlName="telefono2" class="form-control"
                [placeholder]="'Ingrese NIT'">
            <label>NIT</label>
        </div>
    </div>

    <div class="button-section">
        <button mat-flat-button class="btn-success btn-menu" (click)="model ? update() : create()"
            [disabled]="!form.valid || loading">
            <mat-icon>save</mat-icon>
            {{ model ? 'Actualizar' : 'Guardar' }}
        </button>
        <button *ngIf="model" mat-flat-button class="btn-search btn-menu" type="button" (click)="openCustomizables()">
            <mat-icon>tune</mat-icon>
            Customizables
        </button>
    </div>
</form>